import React from 'react'

import { useSelector } from 'react-redux'

import { ActionBarLeft, ActionBarRight, ActionBarWrapper } from '@components/UI/Card/Card.styled'
import { ISelectedSubmissionsContextProps } from '@context/SelectedSubmissions'
import { withSelectedSubmissions } from '@hocs'
import { IApplicationState } from '@store'
import { selectShortlistLink, selectUnshortlistLink } from '@store/submissions'
import ActionBarIconSelection from '../Icon/Selection/Selection'
import ActionBarIconShortlist from '../Icon/Shortlist/Shortlist'
import ActionBarIconUnshortlist from '../Icon/Unshortlist/Unshortlist'

interface IProps {
  submissionId: number
}

interface IInternalProps extends IProps, ISelectedSubmissionsContextProps {}

const SubmissionCardActionBarSelectionMode: React.FC<IInternalProps> = ({
  submissionId,
  deselectSubmission,
  selectSubmission,
  selectedSubmissionIds,
}) => {
  const hasShortlistLink = useSelector((state: IApplicationState) =>
    Boolean(selectShortlistLink(state, submissionId)),
  )
  const hasUnshortlistLink = useSelector((state: IApplicationState) =>
    Boolean(selectUnshortlistLink(state, submissionId)),
  )

  const selected = selectedSubmissionIds.includes(submissionId)

  const toggleSelection = () => {
    if (selected) {
      deselectSubmission(submissionId)
    } else {
      selectSubmission(submissionId)
    }
  }

  return (
    <ActionBarWrapper justifyBetween>
      <ActionBarLeft>
        {hasShortlistLink && <ActionBarIconShortlist submissionId={submissionId} />}
        {hasUnshortlistLink && <ActionBarIconUnshortlist submissionId={submissionId} />}
      </ActionBarLeft>
      <ActionBarRight>
        <ActionBarIconSelection selected={selected} onToggle={toggleSelection} />
      </ActionBarRight>
    </ActionBarWrapper>
  )
}

export default withSelectedSubmissions(SubmissionCardActionBarSelectionMode)
